import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { navigationReducer } from './navigation.reducer';
import { NavigationEffects } from './navigation.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('navigation', navigationReducer),
    EffectsModule.forFeature([NavigationEffects]),
  ],
})
export class NavigationModule {}
